var selectedScheme = 'navigation-left';
var selectedColour = '';
var selectedFont = '';

$('#font_family').change(function(){
    $('body').removeClass(selectedFont).addClass($(this).val());
    selectedFont = $(this).val();
});

$('.demo-close').click(function(){
    $('.demo-toggle-panel').toggleClass('demo-toggle-panel-close');
});

$('.btn-theme-default').click(function(){
    $('body').removeClass(selectedColour)
    selectedColour = '';
});

$('.btn-theme-navy').click(function(){
    $('body').removeClass(selectedColour)
    $('body').addClass('theme-navy');
    selectedColour = 'theme-navy';
});

$('.btn-theme-navy').click(function(){
    $('body').removeClass(selectedColour)
    $('body').addClass('theme-navy');
    selectedColour = 'theme-navy';
});

$('.btn-theme-blue').click(function(){
    $('body').removeClass(selectedColour)
    $('body').addClass('theme-blue');
    selectedColour = 'theme-blue';
});

$('.btn-theme-green').click(function(){
    $('body').removeClass(selectedColour)
    $('body').addClass('theme-green');
    selectedColour = 'theme-green';
});

$('.btn-theme-brown').click(function(){
    $('body').removeClass(selectedColour)
    $('body').addClass('theme-brown');
    selectedColour = 'theme-brown';
});

$('.btn-theme-red').click(function(){
    $('body').removeClass(selectedColour)
    $('body').addClass('theme-red');
    selectedColour = 'theme-red';
});

$('.btn-theme-pink').click(function(){
    $('body').removeClass(selectedColour)
    $('body').addClass('theme-pink');
    selectedColour = 'theme-pink';
});

$('.btn-theme-purple').click(function(){
    $('body').removeClass(selectedColour)
    $('body').addClass('theme-purple');
    selectedColour = 'theme-purple';
});
